import {
    Building2, Users, HardHat, Landmark, Megaphone, Cpu,
} from "lucide-react";
import { Container, Reveal } from "./common";

const industries = [
    [Building2, "Real Estate"],
    [Users, "Staffing"],
    [HardHat, "Construction"],
    [Landmark, "Financial Services"],
    [Megaphone, "Digital Agencies"],
    [Cpu, "Technology"],
];

const TrustBar = () => (
    <section data-testid="trust-bar-container" className="border-y border-[#F1F5F9] bg-white py-12">
        <Container>
            <Reveal>
                <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#94A3B8]">
                    Built for growing businesses across industries
                </p>
            </Reveal>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
                {industries.map(([Icon, label], i) => (
                    <Reveal key={label} delay={i * 0.06}>
                        <span className="group flex items-center gap-2.5 text-[#64748B] transition-colors hover:text-[#15803D]">
                            <span className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#E5E7EB] bg-[#F8FAFC] transition-colors group-hover:border-[#16A34A]/30 group-hover:bg-[#F0FDF4]">
                                <Icon className="h-4 w-4" />
                            </span>
                            <span className="text-sm font-semibold">{label}</span>
                        </span>
                    </Reveal>
                ))}
            </div>
        </Container>
    </section>
);

export default TrustBar;
